<template>

    <div v-if="!isLoading">
        <!-- Section for Header -->
        <div class="container header-section">
            <div class="row header-match" v-if="match!==null">

                <div class="col-md-8">
                  <h2 class="text-left text-color"><router-link :to="{name:'event',params:{id:match.tournament.id}}">{{ match.tournament_name }}</router-link></h2>
                    <MatchHeader :match-info="this.match"></MatchHeader>
                </div>
                <div class="col-md-4">
                    <h2 class="text-left">Jogos</h2>
                    <MatchList :amount="6"></MatchList>
                </div>

            </div>
        </div>

        <div class="container stream-area" v-if="match.meta.hasOwnProperty('stream_embed_url') && match.status !== 'finished'">
          <div class="row">
            <div class="col-md-12">
              <h2 class="text-left">Transmissão</h2>
              <iframe :src="match.meta.stream_embed_url.value" width="99.5%" height="650px" frameborder="0" style="border: 0;"></iframe>
            </div>
          </div>
        </div>

        <!-- Section for Vetos -->
        <div class="container vetos-header" v-if="match.vetos">
            <div class="row">
                <div class="col-md-12">
                    <h2 class="text-left">Vetos</h2>
                </div>
            </div>
        </div>

        <div class="vetos-section bg-color" v-if="match.vetos">

            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="veto-info">
                            <div class="single-veto" v-for="veto in match.vetos" :class="( (match.status==='live' && mapsFormated.hasOwnProperty(veto.map.id) && mapsFormated[veto.map.id].teams.home.pivot.score===0 && mapsFormated[veto.map.id].teams.away.pivot.score===0) || (match.status!=='live') ? '':'not-featured')">
                                     <div class="map-image" v-bind:style="'background-image:linear-gradient(180deg, rgba(0, 0, 0, 0) 45.7%, #141F26 100%),url('+veto.map.picture+')'">
                                    <div class="map-info">
                                        <div class="map-name">{{ veto.map.name }}</div>
                                        <div class="demo-download" v-if="mapsFormated.hasOwnProperty(veto.map.id) && mapsFormated[veto.map.id].demo===1">D</div>
                                    </div>
                                </div>
                                <div class="bottom-info">
                                     <div class="veto-status">
                                         <div class="veto-team">
                                           <img :src="$urlOrDefault(match.teams_formatted[veto.team].team.logo_picture,'logo')">
                                         </div>
                                         <span class="veto-type" :class="(veto.veto==='random'?'bg-color':'veto-'+veto.veto)">
                                             {{ veto.veto_text }}
                                         </span>
                                     </div>
                                     <div class="score-status">
                                         <template v-if="mapsFormated.hasOwnProperty(veto.map.id) && mapsFormated[veto.map.id].teams!==null">
                                            <div class="score">{{ mapsFormated[veto.map.id].teams.home.pivot.score }}</div>
                                            <div class="score">{{ mapsFormated[veto.map.id].teams.away.pivot.score }}</div>
                                         </template>

                                         <template  v-if="!mapsFormated.hasOwnProperty(veto.map.id) || mapsFormated[veto.map.id].teams===null || mapsFormated[veto.map.id].teams.length < 2 ">
                                            <div class="no-score">-</div>
                                         </template>
                                     </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>


        <!-- Section for stats -->

        <div class="stats-section" v-if="scoreboard!==null">
            <div class="container header-stats">
                <div class="row">
                    <div class="col-md-4">
                        <h2 class="text-left">Estatísticas</h2>
                    </div>

                    <div class="col-md-8">
                        <div class="menu-select-scoreboard">

                            <div class="nav-item"  v-bind:class="selectedscoreboard==='all' ? 'text-color border-color active':''">
                                <a class="nav-link" v-on:click="getScoreboard('all')">Todos os mapas</a>
                            </div>

                            <div class="nav-item"  v-for="map in match.maps " v-if="map.stats!==null" v-bind:class="selectedscoreboard===map.id ? 'text-color border-color active' : ''">
                                <a class="nav-link" v-on:click="getScoreboard(map.id)">{{ map.map.name }}</a>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div class="container" v-if="scoreboard!==null && selectedscoreboard!=null">

                <div class="row">

                    <div class="col-md-12 stats-info">

                        <table class="table table-dark">
                            <!-- Home team -->
                            <template v-for="team in this.match.teams_formatted" v-if="scoreboard[selectedscoreboard].hasOwnProperty(team.data.team_id)">
                                <thead>
                                <tr>
                                    <th class="text-center" style="width:5%;">
                                      <img :src="$urlOrDefault(team.team.logo_picture,'logo')" height="35">
                                    </th>
                                    <th class="text-left team-name" style="width: 60%;">{{ team.data.name }}</th>
                                    <th class="text-center stats-title">K-D</th>
                                    <th class="text-center stats-title">+/-</th>
                                    <th class="text-center stats-title">ADR</th>
                                    <th class="text-center stats-title">KAST</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="stats in sortedArray(scoreboard[selectedscoreboard][team.data.team_id],'kills')">
                                    <td class="text-center player-flag">
                                        <img :src="`${getImageUrl('/assets/img/flags/') + match.stats.players[stats.playerid].country.toLowerCase()}.svg`" height="16">
                                        <!-- <img src="../assets/img/flags/pt.svg" height="16"> -->
                                    </td>
                                    <td class="text-left player-name" v-html="getPlayerFullName(match.stats.players[stats.playerid])">
                                    </td>
                                    <td class="text-center">
                                        {{stats.kills}}-{{stats.deaths}}
                                    </td>
                                    <td class="text-center">
                                        <template>
                                            <span class="winner-color" v-if="stats.kills-stats.deaths >= 0">{{ stats.kills-stats.deaths }}</span>
                                            <span class="looser-color" v-if="stats.kills-stats.deaths < 0">{{ stats.kills-stats.deaths }}</span>
                                        </template>
                                    </td>
                                    <td class="text-center">
                                        {{ +(stats.damage / stats.match_rounds).toFixed(1) }}
                                    </td>
                                    <td class="text-center">
                                        {{+(stats.kast).toFixed(1)}} %
                                    </td>
                                </tr>
                                </tbody>
                            </template>
                        </table>
                    </div>

                </div>
            </div>
        </div>

        <!-- Section for lineup -->
        <div class="lineup-section">
          <div class="container">
            <div class="row">
              <div class="col-md-4">
                <h2 class="text-left">Lineups</h2>
              </div>
            </div>

            <div class="row">

              <div class="col-md-6">
                <div class="single-team-lineup text-white text-left">
                  <img :src="$urlOrDefault(match.teams_formatted['home'].team.logo_picture,'logo')" height="55"> <span>{{ match.teams_formatted.home.data.name }}</span>
                </div>
                <div class="single-player-lineup text-left text-white" v-for="pl in match.teams_formatted.home.players">
                  <img :src="`${getImageUrl('/assets/img/flags/') + pl.country.toLowerCase()}.svg`" height="16"> {{ pl.name.split(' ',2)[0] }} <b>"{{ pl.nick }}"</b> {{ pl.name.split(' ',2)[1] }}
                </div>
              </div>
              <div class="col-md-6">
                <div class="single-team-lineup text-white text-left">
                  <img :src="$urlOrDefault(match.teams_formatted['away'].team.logo_picture,'logo')" height="55"> <span>{{ match.teams_formatted.away.data.name }}</span>
                </div>
                <div class="single-player-lineup text-left text-white" v-for="pl in match.teams_formatted.away.players">
                  <img :src="`${getImageUrl('/assets/img/flags/') + pl.country.toLowerCase()}.svg`" height="16"> {{ pl.name.split(' ',2)[0] }} <b>"{{ pl.nick }}"</b> {{ pl.name.split(' ',2)[1] }}
                </div>
              </div>

            </div>
          </div>
        </div>

        <!-- Section for History -->
        <div class="history-section">
            <div class="container header-stats">
                <div class="row">
                    <div class="col-md-4">
                        <h2 class="text-left">Histórico</h2>
                    </div>

                    <div class="col-md-8">
                        <div class="menu-select-scoreboard">

                            <div class="nav-item"  v-bind:class="tabHistory==='history' ? 'text-color border-color active':''">
                                <a class="nav-link" v-on:click="selectHistory('history')">Todo o histórico</a>
                            </div>

                            <div class="nav-item" v-bind:class="tabHistory==='h2h' ? 'text-color border-color active':''">
                                <a class="nav-link" v-on:click="selectHistory('h2h')">Frente a frente</a>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div class="container"  v-if="(matchesprevhome!==null||matchesprevaway!==null)&& tabHistory==='history'">
                <div class="row  history-info">
                    <div class="col-sm-12 col-md-6">
                        <div class="team-title text-left">
                            <img :src="$urlOrDefault(match.teams_formatted['home'].team.logo_picture,'logo')"> {{ match.teams_formatted['home'].data.name }}
                        </div>

                        <div class="team-matches">
                            <template  v-for="hmatch in matchesprevhome">
                                <PrevMatch :match="hmatch" :currteam="match.teams_formatted['home']" ></PrevMatch>
                            </template>

                        </div>
                    </div>

                    <div class="col-sm-12 col-md-6">
                        <div class="team-title text-right">
                            {{ match.teams_formatted['away'].data.name }} <img :src="$urlOrDefault(match.teams_formatted['away'].team.logo_picture,'logo')">
                        </div>

                        <div class="team-matches">
                            <template  v-for="hmatch in matchesprevaway">
                                <PrevMatch :match="hmatch" :currteam="match.teams_formatted['away']" ></PrevMatch>
                            </template>

                        </div>
                    </div>
                </div>
            </div>

            <div class="container" v-if="h2hdata!==null && tabHistory==='h2h'">

                <div class="row  history-info">
                    <div class="col-sm-12 col-md-6">
                        <div class="team-title text-left">
                          <img :src="$urlOrDefault(match.teams_formatted['home'].team.logo_picture,'logo')"> {{ match.teams_formatted['home'].data.name }}
                        </div>
                    </div>

                    <div class="col-sm-12 col-md-6">
                        <div class="team-title text-right">
                            {{ match.teams_formatted['away'].data.name }} <img :src="$urlOrDefault(match.teams_formatted['away'].team.logo_picture,'logo')">
                        </div>
                    </div>
                </div>

                <div class="row h2hlist">

                    <div class="col-sm-12 col-md-12">
                        <div class="h2h-game" v-for="h2hmatch in h2hdata">
                            <div class="h2h-date text-left"><img :src="getImageUrl('/assets/icons/calendar_icon.svg')" height="15">  {{ formatDate(h2hmatch.date_time_jogo,true) }}</div>
                            <div class="h2h-teamA-score text-right">{{ h2hmatch.teams_formatted[h2hmatch.teams_association['home']].data.score }}</div>
                            <div class="h2h-teamB-score text-left">{{ h2hmatch.teams_formatted[h2hmatch.teams_association['away']].data.score }}</div>

                            <div class="h2h-tournament text-right">{{ h2hmatch.tournament_name }}</div>
                        </div>
                    </div>



                </div>

            </div>
        </div>

        <LatestNews :news="news"></LatestNews>

    </div>


</template>

<script>
    import MatchRepository from '../api/MatchRepository';
    import Funcs from '../functions'
    import StatsRepository from "../api/StatsRepository";
    import PrevMatch from "../components/Match/PrevMatch";
    import MatchHeader from "../components/Match/MatchHeader";
    import MatchList from "../components/Match/MatchList";
    import RtpArenaApi from "@/api/RtpArenaApi";
    import LatestNews from "@/components/Event/LatestNews";

    export default {
        name: "Match",
        components: {LatestNews, MatchList, MatchHeader, PrevMatch},
        data: function(){
            return {
                isLoading: false,
                match:null,
                scoreboard:null,
                selectedscoreboard:null,
                matchesprevhome:null,
                matchesprevaway:null,
                tabHistory:'history',
                h2hdata:null,
                news:null,
            }
        },
        created: function(){
            this.getData();
        },
      computed: {
          mapsFormated(){
              if(this.match!==null){
                  let maps={};

                  for(let m in this.match.maps){
                      if(this.match.maps.hasOwnProperty(m)){
                          let map = this.match.maps[m];

                          let fm={
                              demo: map.demo,
                              demo_path: map.demo_path,
                              id:map.id,
                              map_id:map.map_id,
                              map:map.map,
                              stats:map.stats,
                              teams:{}
                          };

                          for(let k in map.teams){
                              fm.teams[map.teams[k].pivot.side]=map.teams[k];
                          }

                          maps[map.map_id]=fm;

                      }
                  }

                  return maps;

              } else {
                  return null;
              }
          }
        },
        methods: {
            async getData(){
                this.isLoading=true;
                const { data } = await MatchRepository.getMatch(this.$route.params.id);
                this.isLoading = false;
                this.match=data;

                if(this.match.stats !== null){
                    MatchRepository.getStatsMatch(this.$route.params.id).then((response) => {
                        this.scoreboard={};
                        this.scoreboard['all']=Funcs.groupBy(response.data,'team');
                        this.selectedscoreboard="all";
                    });
                }

                if(data.tournament.metas !== null && data.tournament.metas.hasOwnProperty('arena_tournament_url')){
                  RtpArenaApi.getNews({'post_type':'any','quantity':4,'event':data.tournament.metas.arena_tournament_url.value}).then(
                      response => {
                        this.news=response.data;
                      }
                  );
                }

                if(this.match !== null){

                    MatchRepository.get({amount:5, team_id:this.match.teams_formatted['home'].team.id, end_date:this.match.date_time_jogo}).then(
                        response => {
                            this.matchesprevhome=response.data.data;
                        }
                    );

                    MatchRepository.get({amount:5, team_id:this.match.teams_formatted['away'].team.id, end_date:this.match.date_time_jogo}).then(
                        response => {
                            this.matchesprevaway=response.data.data;
                        }
                    );

                }

            },
            sortedArray: function(array,field) {
                function compare(a, b) {
                    if (parseInt(a[field]) > parseInt(b[field]))
                        return -1;
                    if (parseInt(a[field]) < parseInt(b[field]))
                        return 1;
                    return 0;
                }

                return array.sort(compare);
            },

            getPlayerFullName: function(player){
                return Funcs.getPlayerFullName(player.nick,player.name);
            },

            formatDate: function(date,year=false){
                return Funcs.formatDate(date,false,year);
            },

            getImageUrl: function(url){
                return Funcs.getImageUrl(url);
            },

            async getScoreboard(mapid){

                if(this.scoreboard.hasOwnProperty(mapid)){
                    this.selectedscoreboard=mapid;
                } else {
                    const stats = await StatsRepository.getFrontend(mapid);

                    if(stats.status===200){
                        this.scoreboard[mapid]=Funcs.groupBy(stats.data,'team');
                        this.selectedscoreboard=mapid;
                    }
                }
            },

            async selectHistory(to){

                if(this.h2hdata!==null && to === 'h2h'){
                    this.tabHistory='h2h';
                } else if (this.h2hdata === null && to === 'h2h'){
                    const { data } = await MatchRepository.getVsMatch(this.$route.params.id);
                    this.h2hdata=data;
                    this.tabHistory='h2h';
                }

                if(to === 'history'){
                    this.tabHistory='history';
                }
            }
        }
    }
</script>

<style scoped>


    .header-match {
        margin-top: 20px;
    }

    h2 {
        margin-bottom: 15px;
    }

    .vetos-header {
        margin-top: 25px;
    }

    .vetos-section {
        padding-bottom: 20px;
    }

    .veto-info {
        width: 100%;
        display: flex;
        flex-wrap: nowrap;
    }

    .veto-info > .single-veto {
        width:100%;
        height: 130px;
        margin-left: 8px;
    }

    .veto-info > .single-veto.not-featured {
        opacity: 0.5;
    }

    .single-veto > .bottom-info {
        width: 100%;
        height: 36px;
    }

    .single-veto > .bottom-info > .veto-status {
        background-color: rgba(20, 31, 38, 0.8);
        height: 100%;
        width: 60%;
        float: left;
        border-bottom-left-radius: 5px;
        text-align: center;
    }

    .single-veto > .bottom-info > .score-status {
        background-color: #141F26;
        height: 100%;
        width: 40%;
        float: right;
        border-bottom-right-radius: 5px;
    }

    .single-veto > .bottom-info > .score-status > .score {
        width: 50%;
        height: 100%;
        color:#FFF;
        float: left;
        line-height: 36px;
    }

    .single-veto > .bottom-info > .score-status > .no-score {
        font-size: 30px;
        line-height: 36px;
        width: 100%;
    }

    .single-veto > .bottom-info > .score-status > .score:first-child {
        border-right: 1px solid #0A151C;
    }
    .single-veto > .bottom-info > .score-status > .score:last-child {
        border-left: 1px solid #0A151C;
    }

    .single-veto > .bottom-info > .veto-status > .veto-team {
        width: 30%;
        height: 100%;
        text-align: center;
        line-height: 34px;
        float: left;
    }

    .single-veto > .bottom-info > .veto-status > .veto-team > img {
        max-height: 70%;
        vertical-align: middle;
    }

    .single-veto > .bottom-info > .veto-status > .veto-type {
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 11px;
        color:#000;
        line-height: 36px;
        padding: 2.5px 10px;
        border-radius:2px;
    }

    .veto-type.veto-pick {
        background-color: #64F8C1;
    }

    .veto-type.veto-ban,.veto-type.veto-left_over {
        background-color: #5A656C;
    }

    .veto-info > .single-veto:first-child{
        margin-left: 0;
    }

    .single-veto > .map-image {
        height: 94px;
        background-position: center center;
        background-size: cover;
        background-repeat: no-repeat;
        position: relative;
    }

    .single-veto > .map-image > .map-info {
        width: 100%;
        height:20px;
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 20px;
        color:#FFF;
        position: absolute;
        bottom: 10px;
        left:0;
    }

    .single-veto > .map-image > .map-info > .map-name {
        width: 80%;
        height: 100%;
        text-align: left;
        padding-left: 10px;
        line-height: 20px;
        float: left;
    }

    .single-veto > .map-image > .map-info > .demo-download {
        text-align: right;
        padding-right: 10px;
    }

    .stats-section {
        background-color: #0A151C;
    }

    .header-stats {
        line-height: 50px;
        height:50px;
        margin-bottom: 20px;
    }

    .header-stats h2 {
        line-height: 50px;
        height: 50px;
        padding-top: 0px;
        padding-bottom: 0px;
        margin-top: 0px;
    }

    .header-stats > .row {
        height: 50px;
    }

    .header-stats .menu-select-scoreboard {
        float: right;
        background-color: #141F26;
        display: inline-flex;
        flex-direction: row;
        text-align: center;
    }

    .header-stats .menu-select-scoreboard > .nav-item {
        margin-right: 1px;
        margin-left: 1px;
        border-top: 3px solid #28333A;
        display: block;
        width: 200px;
    }

    .header-stats .menu-select-scoreboard > .nav-item:first-child {
        margin-left:0;
    }
    .header-stats .menu-select-scoreboard > .nav-item:last-child {
        margin-right:0;
    }

    .header-stats .menu-select-scoreboard > .nav-item > .nav-link {
        color: #C8C8C8;
        text-transform: uppercase;
        font-family: Roboto;
        font-style: normal;
        font-weight: 600;
        font-size: 13px;
    }

    .header-stats .menu-select-scoreboard > .nav-item.active {
        background-color: #0A151C;
    }

    .header-stats .menu-select-scoreboard > .nav-item.text-color > .nav-link {
        color:inherit;
    }

    .stats-info .table {
        background-color: transparent;
        border: none;
    }

    .stats-info table thead {
        line-height: 80px;
        height: 80px;
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        letter-spacing: -0.4px;
        text-align: left;
    }

    .stats-info .table thead th {
        border:none;
        vertical-align: middle;
    }

    .stats-info .team-name {
        font-weight: 300;
        vertical-align: middle;
    }

    .stats-info .stats-title {
        font-weight: bold;
        color: #78838A;
        font-size: 14px;
        vertical-align: middle;
    }

    .stats-info tbody td {
        font-size: 14px;
    }

    .stats-info tbody tr:nth-child(odd){
        background-color: rgba(40, 51, 58, 0.51);
    }

    .stats-info .table td {
        border-top-color: rgba(0,0,0,0.2);
    }

    .history-section {
        background-color: #0A151C;
        margin-top: 5px;
        padding-bottom: 20px;
        display: none;
    }

    .history-info {
        border-radius: 8px;
    }

    .history-info .team-title {
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        color:#FFF;
        font-size: 16px;
        height: 60px;
        line-height: 60px;
    }

    .history-info .team-title > img {
        height: 40px;
        margin-right: 10px;
    }

    .history-info .team-title.text-right > img {
        margin-right: 0;
        margin-left: 10px;
    }

    .h2h-game {
        width: 100%;
        height: 40px;
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        color: #FFF;
        font-size: 14px;
        line-height: 40px;
    }

    .h2h-game > div {
        float: left;
    }

    .h2h-game:nth-child(odd){
        background-color: #28333A;
    }

    .h2h-game > .h2h-date {
        width: 30%;
        height: 100%;
        padding-left: 20px;
        display: inline-block;
    }

    .h2h-teamA-score {
        width: 20%;
        height: 100%;
        display: inline-block;
        padding-right: 10px;
        border-right: 1px solid #0A151C;
    }

    .h2h-teamB-score {
        width: 20%;
        height: 100%;
        display: inline-block;
        padding-left: 10px;
        border-left: 1px solid #0A151C;
    }

    .h2h-tournament {
        width: 30%;
        height: 100%;
        padding-right: 20px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .table-dark {
        color:#FFF;
    }

    .stats-info table td {
        padding: 0.95rem;
        vertical-align: top;
        border-top: 1px solid #dee2e6;
    }

    .single-player-lineup {
      height: 35px;
      line-height: 32px;
      padding-left: 5px;
      font-family: Roboto;
      font-weight: 500;
      font-size: 13px;
    }

    .single-player-lineup > img {
      margin-right: 5px;
    }

    .single-player-lineup:nth-child(even){
      background-color: #28333A;
    }

    .single-team-lineup {
      font-size: 16px;
      font-family: Roboto;
      font-weight: 500;
      margin-left: 10px;
    }

    .lineup-section {
      background-color: #0A151C;
      padding-top: 10px;
      padding-bottom: 10px;
    }

    .menu-select-scoreboard .nav-item:hover {
      cursor: pointer;
    }


</style>

<style>
    .history-info .team-matches > div:nth-child(odd) > div{
        background-color: #28333A;
    }

    #app {
      background: #141F26;
      min-height: 100vh;
    }
</style>